
import { useSearchParams } from 'react-router-dom';
import { CampaignWizardNew as CampaignWizard } from './CampaignWizardNew';

interface CampaignManagerProps {
  onBack: () => void;
}

export const CampaignManager = ({ onBack }: CampaignManagerProps) => {
  const [searchParams] = useSearchParams();
  const draftId = searchParams.get('draft');

  const handleSuccess = () => {
    // Retourner au dashboard après succès
    onBack();
  };

  const handleCancel = () => {
    // Retourner au dashboard si annulation
    onBack();
  };

  return (
    <div className="space-y-6">
      {/* Wizard de création */}
      <CampaignWizard 
        onSuccess={handleSuccess}
        onCancel={handleCancel}
        draftId={draftId || undefined}
        isDialog={false}
      />
    </div>
  );
};
